export default __webpack_public_path__ + "media/images/sunflower-row-2985c73f03679a5e3f548589a50a0c7e.svg";